// Realistic layered grass silhouette generated as a repeating SVG tile.
const W = 150, H = 56;
function build() {
  let seed = 20240607;
  const rnd = () => { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; };
  const greens = ["#0e3814", "#14481B", "#1C5A2E", "#2E7D32", "#3f9a44"];
  const layers = [
    { n: 34, minH: 14, maxH: 28, cols: [0, 1], op: 1 },
    { n: 26, minH: 24, maxH: 42, cols: [1, 2], op: 1 },
    { n: 16, minH: 34, maxH: 54, cols: [2, 3, 4], op: 0.96 },
  ];
  let blades = "";
  layers.forEach((L) => {
    for (let i = 0; i < L.n; i++) {
      const x = rnd() * (W + 20) - 10;
      const h = L.minH + rnd() * (L.maxH - L.minH);
      const w = 1.5 + rnd() * 2.0;
      const lean = (rnd() - 0.5) * (h * 0.7);
      const tipx = x + lean, tipy = H - h;
      const midY = H - h * 0.5;
      const color = greens[L.cols[Math.floor(rnd() * L.cols.length)]];
      const c1 = (x + lean * 0.35).toFixed(1);
      const c2 = (x + w + lean * 0.35).toFixed(1);
      blades += `<path d='M${x.toFixed(1)},${H} Q${c1},${midY.toFixed(1)} ${tipx.toFixed(1)},${tipy.toFixed(1)} Q${c2},${midY.toFixed(1)} ${(x + w).toFixed(1)},${H} Z' fill='${color}' opacity='${L.op}'/>`;
    }
  });
  return `<svg xmlns='http://www.w3.org/2000/svg' width='${W}' height='${H}' viewBox='0 0 ${W} ${H}' preserveAspectRatio='xMidYMax slice'>${blades}</svg>`;
}
const GRASS_URL = `url("data:image/svg+xml,${encodeURIComponent(build())}")`;

export default function GrassBorder({ className = "", height = 46 }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none w-full ${className}`}
      style={{ height, backgroundImage: GRASS_URL, backgroundRepeat: "repeat-x", backgroundPosition: "center bottom", backgroundSize: `${W}px ${height}px` }}
    />
  );
}
